'use strict';

module.exports = /*@ngInject*/
function() {
    return {
        template: '<div class="tool-tip"></div>',
        scope: {
            tooltipText: '@toolTip'
        },
        link: function(scope, element, attrs) {
            element.bind('mouseover', function() {
                jQuery(this)
                .find('.tool-tip')
                .text(scope.tooltipText)
                .show();
            });

            element.bind('mouseout', function() {
                jQuery(this)
                .find('.tool-tip')
                .hide();
            });
        }
    };
};
